import { useState } from 'react';
import createPersistedState from 'use-persisted-state';
const usePersistedArray = function (key, initial, maxItems) {
  let useCaseSensitiveFilter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const useArrayState = createPersistedState(key);
  const [data, setData] = useArrayState(initial);
  const [filteredData, setFilteredData] = useState(initial);
  const caseSensitiveFilter = query => {
    setFilteredData(data.filter(item => item.indexOf(query) > -1));
  };
  const caseInsensitiveFilter = query => {
    setFilteredData(data.filter(item => item.toUpperCase().indexOf(query.toUpperCase()) > -1));
  };
  return {
    data,
    addData: item => {
      if (data.indexOf(item) < 0) {
        if (data.length >= maxItems) {
          data.pop();
        }
        setData([item, ...data]);
      }
    },
    filteredData,
    filterData: useCaseSensitiveFilter ? caseSensitiveFilter : caseInsensitiveFilter
    // remove: () => setCount(currentCount => currentCount - 1),
  };
};
export default usePersistedArray;